import PropTypes from 'prop-types'
import NextLink from 'next/link'
import { beautifyUrlPath } from '../../../../common/utils'

const PaginationItem = ({ label, path, current }) => (
  <div className="px-1 sm:px-2">
    {['...', current].includes(label) ? (
      <p className="text-gray-245">{label}</p>
    ) : (
      <NextLink
        href={beautifyUrlPath(path)}
        className="hover:text-blue-700"
        prefetch={false}
      >
        {label}
      </NextLink>
    )}
  </div>
)

PaginationItem.defaultProps = {
  current: null,
}
PaginationItem.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  path: PropTypes.string.isRequired,
  current: PropTypes.number,
}

export default PaginationItem
